<script lang="ts" module>
  import { type Snippet } from 'svelte';

  import { TeoCore } from '@/teoCore/TeoCore';

  import { setupJotaiStoreContext } from '../jotai-svelte/JotaiStoreContext';

  // interface TeoContextState {
  //   core: TeoCore;
  //   activeText: TeoText;
  // }

  // const TeoContext = Symbol('TeoContext');

  // class TeoContextValue {
  //   #subscribe: () => void;

  //   #value = {} as TeoContextState;

  //   constructor(core: TeoCore) {
  //     this.#value = {
  //       core,
  //       activeText: core.activeText,
  //     };
  //     this.#subscribe = createSubscriber((update) => {
  //       return core.events.addEventListener('activeTextChanged', (activeText) => {
  //         this.#value.activeText = activeText;
  //         update();
  //       });
  //     });
  //   }

  //   get core() {
  //     // the provider acutally remounts if the core changes, so we don't need to subscribe to it
  //     // this.#subscribe();
  //     return this.#value.core;
  //   }

  //   get activeText() {
  //     this.#subscribe();
  //     return this.#value.activeText;
  //   }
  // }

  // export function setTeoContext(core: TeoCore) {
  //   setContext(TeoContext, new TeoContextValue(core));
  // }

  // export function useTeoContext() {
  //   if (!hasContext(TeoContext)) {
  //     throw new Error('No parent with `setTeoCoreContext` found');
  //   }
  //   return getContext<TeoContextState>(TeoContext);
  // }

  // export function useTeoCore() {
  //   const ctx = useTeoContext();
  //   return ctx.core;
  // }
</script>

<script lang="ts">
  let { teoCore, children }: { teoCore: TeoCore; children: Snippet } = $props();
  //  setTeoContext(teoCore);
  setupJotaiStoreContext(teoCore);
</script>

{@render children()}
